import { render, staticRenderFns } from "./WInputNumber.vue?vue&type=template&id=5df9889a&scoped=true&"
import script from "./WInputNumber.vue?vue&type=script&lang=js&"
export * from "./WInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df9889a",
  null
  
)

export default component.exports